/**
 * 请求库的拦截器配置
 * @file 请求库拦截器封装
 */
import * as fn from './function'
import {
  getToken,
  getTenantId
} from '@/utils/authStore'

export function interceptors(service) {
  // 请求的配置
  service.interceptors.request.use(
    config => {
      if (config.url!='connect/token'&&config.url!='api/deer/my-profile'&&config.url!='api/deer/my-profile/get-permissions') {
        if (getTenantId()) {
          config.headers.__tenant = getTenantId();
        }
      }
      
      // 租户只能获取数据
      // if (getTenantId()&&config.method!='get') {
      //   fn.message('当前用户没有相关操作权限');
      //   return false
      // }
      if (getToken()&&config.url!='connect/token') {
        config.headers.Authorization = `Bearer ${getToken()}`;
      }
      return config
    },
    error => {
      Promise.reject(error)
    }
  )

  // 响应的配置
  service.interceptors.response.use(
    res => {
      // 拦截文件流下载
      if (res.headers['content-type'] === 'application/octet-stream') {
        return res.data
      }
      if (!res.config.url.includes('connect/token') && !res.config.url.includes('connect/userinfo')) {
        if (res.data.code == 10200) {
          return res.data
        }
      } else {
        return res
      }
    },
    error => {
      if (error.response) {
        //404与400不提示
        if(error.response.status == 404||error.response.status == 400&&error.response.data.error.code != "Identity.PasswordTooShort"){
          return Promise.reject(error.response.data);
        }else if(error.response.data.error && error.response.data.error.code == "Identity.DuplicateUserName"){
          // 用户名被占用，自定义消息
          return Promise.reject(error.response.data);
        }else if (error.response.status == 413) {
          fn.errorHandle(error.response.status, '上传文件过大，请刷新页面重试');
          return Promise.reject(error.response.data);
        }else if(error.response.data.error && error.response.data.error.message) {
          //默认拦截错误信息，进行消息提示
          fn.errorHandle(error.response.status, error.response.data.error.message);
        }
      }
    }
  )
}